<template>
  <div class="app-footer">
    <v-footer :app="true" absolute class="footer-background">
      <v-container fluid style="width: 80%">
        <v-row>
          <v-col cols="12" class="text-center">
            <p class="footer-text">
              © 2025 - Zakaria Gasmi. Tous droits réservés.
            </p>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
@import url("https://fonts.google.com/noto/specimen/Noto+Kufi+Arabic?lang=ar_Arab");

.footer-background {
  background-color: #ffeace;
  border-top: 1px solid #e7e7e7;
}

.footer-text {
  font-size: 17px;
  font-weight: 600;
  color: #6c757d;
  text-align: center;
  font-family: "Noto Kufi Arabic", sans-serif;
}
@media (max-width: 566px) {
  .footer-text {
    font-size: 13px;
  }
}
</style>
